const isValidFlightSegments = (flightSegments = []) => {
  if (!Array.isArray(flightSegments) || flightSegments.length === 0) return false;

  return flightSegments.every((fs) => {
    if (!fs) return false;

    const requiredFields = [
      fs.departureDate,
      fs.flightNumber,
      fs.cabin,
      fs.carrierCode?.value,
      fs.origin,
      fs.destination,
    ];

    return !requiredFields.some((field) => !field);
  }) ? true : null;
};

export default isValidFlightSegments;
